<template>
    <div>
        <vxe-modal class-name="select-pro-modal" v-model="proInfo.visible" width="650" height="500" title="请选择" destroy-on-close mask-closable lock-view>
            <template v-slot>
                <div class="select-body" style="display: flex;height: 100%">
                    <div style="width: 40%;height: 100%;">
                        <div style="width: 300px;height: 300px">
                            <img src="https://img12.360buyimg.com/n7/jfs/t1/59022/28/10293/141808/5d78088fEf6e7862d/68836f52ffaaad96.jpg" style="width: 240px;height: 240px">
                        </div>
                    </div>
                    <div style="width: 60%;height: 100%;">
                        <el-row style="margin-top: 10px">
                            <span style="font-size: 20px;font-weight: bold;">Apple iPhone 11(A2223) 128G</span>
                        </el-row>
                        <el-row style="margin-top: 10px" type="flex">
                            <el-col :span="4" style="display: flex;align-items: center">价格</el-col>
                            <el-col :span="20" style="font-size: 20px;font-weight: bold;color: red">
                                <span>¥4999.00</span>
                            </el-col>
                        </el-row>
                        <el-row style="margin-top: 10px" type="flex">
                            <el-col :span="4">颜色</el-col>
                            <el-col :span="20">
                                <el-radio-group v-model="selectColor" class="sku-hide-input">
                                    <el-radio v-for="item in colorList" :label="item" class="radio-item border">{{item}}</el-radio>
                                </el-radio-group>
                            </el-col>
                        </el-row>
                        <el-row style="margin-top: 10px">
                            <el-col :span="4">尺码</el-col>
                            <el-col :span="20">
                                <div style="width: calc(100% - 10px);height: 180px;border: 1px solid #ccc;position: relative">
                                    <div style="height: 155px;overflow-y: auto">
                                        <template v-for="v in versionList">
                                            <el-row type="flex" style="margin: 3px 5px">
                                                <el-col :span="6" style="text-align: center">{{v.name}}</el-col>
                                                <el-col :span="18" style="text-align: center">
                                                    <el-input-number size="mini" :precision="0" :min="0" :step="1" step-strictly v-model.number="v.count" @change="getTotalCount"></el-input-number>
                                                </el-col>
                                            </el-row>
                                        </template>
                                    </div>
                                    <div style="width: 100%;height: 25px;line-height: 25px;text-align: right;background-color: #e3e3e3;bottom: 0;position: absolute">
                                        <span style="color: #337ab7;margin-right: 10px">已选择</span><span style="color: red">{{totalCount}}</span><span style="color: #337ab7;margin-right: 10px"> 件</span>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row style="margin-top: 10px;">
                            <el-col :span="20" style="float: right">
                                <el-button v-if="proInfo.handleType == 1" size="small" type="primary" style="width: calc(100% - 10px)" @click="addToShoppingList">加入购物车</el-button>
                                <el-button v-else size="small" type="primary" style="width: calc(100% - 10px)" @click="payRightAway">立即购买</el-button>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </template>
        </vxe-modal>
    </div>
</template>

<script>
    export default {
        name: "skuSelectModal",
        props:{
            proInfo:{
                type:Object,
                default:function () {
                    return{
                        id:undefined,
                        visible:false,
                        handleType:1,//1加入购物车  2 立即购买
                    }
                }
            }
        },
        data(){
            return{
                colorList:['黑色','白色','黄色','紫色','绿色','红色'],
                versionList:[{name:'通用-37',count:0},{name:'通用-38',count:0},{name:'通用-39',count:0},{name:'通用-40',count:0},{name:'通用-41',count:0},{name:'通用-42',count:0}],
                selectColor:'黑色',
                totalCount:0,
            }
        },
        methods:{
            //根据产品id加载产品数据集sku数据
            loadData(){
                console.log(this.proInfo.id);
            },
            //获取加入购物车的单个商品不同尺码的总数
            getTotalCount(val1,obj){
                let num = 0;
                this.versionList.forEach(item =>{
                    if(item.count != undefined){
                        num += item.count;
                    }
                })
                this.totalCount = num;
            },
            //加入购物清单
            addToShoppingList(){

            },
            //立即购买
            payRightAway(){
                if(this.totalCount == 0){
                    this.$message.warning("请选择商品数量！")
                }
            }
        }
    }
</script>

<style scoped>

</style>
